import MenuItem from '@/components/admin/MenuItem';
import { clientMenu } from '@/components/admin/menuConfig';
import { Link, useNavigate } from 'react-router-dom';
import { useSidebar } from '@/contexts/SidebarContext';

const SidebarClient = () => {
  const navigate = useNavigate();
  const { isCollapsed } = useSidebar();

  return (
    <div className={`h-full flex flex-col ${isCollapsed ? 'p-3 items-center' : 'p-6'}`}>
      <div
        className={`flex items-center gap-3 mb-8 cursor-pointer ${isCollapsed ? 'justify-center w-full' : ''}`}
        onClick={() => navigate('/')}
        title="Sporto"
      >
        {isCollapsed ? (
          <img
            src="https://cdn.sporto.id/sporto-small.svg"
            alt="sporto"
            className="w-8 h-8 object-contain transition-transform duration-200 hover:scale-110"
          />
        ) : (
          <img
            src="https://cdn.sporto.id/sporto-black.png"
            alt="sporto"
            className="h-8 w-auto transition-opacity duration-200"
          />
        )}
      </div>

      <nav className={`space-y-2 w-full ${isCollapsed ? 'flex flex-col items-center' : ''}`}>
        {clientMenu.map((item) => (
          <MenuItem
            key={item.path}
            label={item.label}
            icon={item.icon}
            to={item.path}
            hasChildren={!!item.children}
            collapsed={isCollapsed}
          >
            {item.children?.map((child) => (
              <Link
                key={child.path}
                to={child.path}
                className="block px-3 py-2 rounded-md text-sm text-gray-600 hover:bg-gray-50"
              >
                {child.label}
              </Link>
            ))}
          </MenuItem>
        ))}
      </nav>
    </div>
  );
};

export default SidebarClient;
